module.exports = __webpack_public_path__ + "img/Hongkong-3.e4eaf571.jpg";